'use client'

/**
 * Table reservation form entry point.
 * Legacy schema-picker version: see index.legacy.tsx
 */
import { useIsDesktop } from '@/_hooks/useBreakpoint'
import ReservationFormDesktop from './v2/desktop'
import ReservationFormMobile from './v2/mobile'
import { useReservationForm } from './v2/useReservationForm'

export type { ITableOption } from './index.legacy'
// Rollback: import ReservationFormLegacy from './index.legacy'

export default function ReservationForm({ id }: { id?: string }) {
  const isDesktop = useIsDesktop()
  const formProps = useReservationForm(id)

  if (isDesktop) {
    return <ReservationFormDesktop {...formProps} />
  }

  return <ReservationFormMobile {...formProps} />
}

/*
 * ============================================================
 * LEGACY ENTRY (schema picker UI) — uncomment to restore:
 * ============================================================
 *
 * import ReservationFormLegacy from './index.legacy'
 *
 * export default function ReservationForm({ id }: { id?: string }) {
 *   return <ReservationFormLegacy id={id} />
 * }
 */
